import { createContext, useContext } from "react";

import type { Module } from "~/providers/module-provider";

export interface ModuleContext {
  modules: Module[];
}

export const ModuleContext = createContext<ModuleContext | undefined>(
  undefined,
);

export const useModule = () => {
  const context = useContext(ModuleContext);

  if (!context) {
    throw new Error("useModule must be used within a ModuleProvider");
  }

  return context;
};
